
'use strict';

const Backbone = require('backbone/backbone');
const _ = require('underscore/underscore');

require('./IndexTitle.less');

function isPlaying(audelem) {
    return !audelem.paused;
}

module.exports = Backbone.View.extend({

    el: '.IndexTitle',

    events: {
        'click .IndexTitle-text': 'onTrackClick'
    },

    interval: null,

    initialize: function () {
        _.bindAll(this, 'stop');

        app.vent.on('IndexTitle.stop', this.stop);
    },

    changeDuration: function (player) {
        var percentProgress = (player.currentTime / player.duration * 100).toFixed(2);

        var $track = $(player).closest('.IndexTitle');

        $track.find('.IndexTitle-progress').css({
            'clip-path': `polygon(0 0, ${percentProgress}% 0, ${percentProgress}% 100%, 0 100%)`,
            '-webkit-clip-path': `polygon(0 0, ${percentProgress}% 0, ${percentProgress}% 100%, 0 100%)`
        });
    },

    startInterval: function (player) {
        var self = this;

        this.changeDuration(player);

        this.interval = setInterval(function () {
            self.changeDuration(player);
        }, 100);
    },

    onTrackClick: function () {
        var player = this.$el.find('audio').get(0);

        if (isPlaying(player)) {
            player.pause();
            clearInterval(this.interval);
        } else {
            app.vent.trigger('audio.stopAll');
            player.play();
            this.startInterval(player);
        }
    },

    stop: function (player) {
        var player = this.$el.find('audio').get(0);
        player.pause();
        player.currentTime = 0;

        this.changeDuration(player);
        clearInterval(this.interval);
    }
});


